import _typeof from "@babel/runtime/helpers/typeof";
import _inherits from "@babel/runtime/helpers/inherits";
import _setPrototypeOf from "@babel/runtime/helpers/setPrototypeOf";
function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(e, r) { return new BabelRegExp(e, void 0, r); }; var e = RegExp.prototype, r = new WeakMap(); function BabelRegExp(e, t, p) { var o = RegExp(e, t); return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype); } function buildGroups(e, t) { var p = r.get(t); return Object.keys(p).reduce(function (r, t) { var o = p[t]; if ("number" == typeof o) r[t] = e[o];else { for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++; r[t] = e[o[i]]; } return r; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) { var t = e.exec.call(this, r); if (t) { t.groups = buildGroups(t, this); var p = t.indices; p && (p.groups = buildGroups(p, this)); } return t; }, BabelRegExp.prototype[Symbol.replace] = function (t, p) { if ("string" == typeof p) { var o = r.get(this); return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)(>|$)/g, function (e, r, t) { if ("" === t) return e; var p = o[r]; return Array.isArray(p) ? "$" + p.join("$") : "number" == typeof p ? "$" + p : ""; })); } if ("function" == typeof p) { var i = this; return e[Symbol.replace].call(this, t, function () { var e = arguments; return "object" != _typeof(e[e.length - 1]) && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e); }); } return e[Symbol.replace].call(this, t, p); }, _wrapRegExp.apply(this, arguments); }
import { NLPSearchResultFormat } from '../../../../ai-answer-dialog/types';
import { EditedDefinitionScope } from '../types';
export var getQuerySpecsPerEntity = function getQuerySpecsPerEntity(query) {
  var pageOrBlogRegex = /spaces\/.*\/(pages|blog)/;
  var spaceRegex = /https:\/\/[^\/]+\/wiki\/spaces\/(?!.*\/(pages|blog)).*/;
  var confluenceTinyRegex = /*#__PURE__*/_wrapRegExp(/\/wiki\/x\/([^\/(?)]+)$/, {
    resourceId: 1
  });
  var queryParts = query.split('/');
  var queryParamsRemoved = query.split('?')[0];
  if (query.match(pageOrBlogRegex)) {
    // e.g. https://hello.atlassian.net/wiki/spaces/AAI/pages/3665fakeId/Test+Page+Title
    return {
      searchQuery: queryParts[queryParts.length - 1],
      entities: ['ati:cloud:confluence:page', 'ati:cloud:confluence:blogpost'],
      spacesFilter: undefined
    };
  } else if (query.match(spaceRegex)) {
    // e.g. https://hello.atlassian.net/wiki/spaces/SK1/overview
    var spacesIndex = queryParts.indexOf('spaces');
    return {
      searchQuery: '',
      entities: ['ati:cloud:confluence:space'],
      spacesFilter: [spacesIndex > -1 ? queryParts[spacesIndex + 1] : '']
    };
  } else if (queryParamsRemoved.match(confluenceTinyRegex)) {
    // e.g. https://hello.atlassian.net/wiki/x/4c942w
    return {
      searchQuery: '',
      entities: ['ati:cloud:confluence:page', 'ati:cloud:confluence:blogpost'],
      spacesFilter: undefined,
      needsLinkResolution: true
    };
  }
  return {
    searchQuery: query,
    entities: ['ati:cloud:confluence:page', 'ati:cloud:confluence:blogpost', 'ati:cloud:confluence:space'],
    spacesFilter: undefined
  };
};
export var getEntityIdInScope = function getEntityIdInScope(_ref) {
  var selectedScope = _ref.selectedScope,
    productScopes = _ref.productScopes,
    cloudId = _ref.cloudId;
  var contentARI = '';
  var spaceARI = '';
  var projectARI = '';
  if ('contentARI' in productScopes) {
    contentARI = productScopes.contentARI;
    spaceARI = productScopes.spaceARI;
  }
  if ('projectARI' in productScopes) {
    projectARI = productScopes.projectARI;
  }
  switch (selectedScope) {
    case EditedDefinitionScope.PAGE:
    case EditedDefinitionScope.BLOGPOST:
      return contentARI;
    case EditedDefinitionScope.SPACE:
      return spaceARI;
    case EditedDefinitionScope.PROJECT:
      return projectARI;
    default:
      return cloudId;
  }
};
export var mapCreatedDefinitionToNLPSearchType = function mapCreatedDefinitionToNLPSearchType(definitionDetails) {
  var _definitionReferenceD, _definitionDetails$ed, _definitionDetails$ed2;
  var definitionReferenceDetails = definitionDetails.confluenceEntity;
  return {
    nlpResult: definitionDetails.definition,
    uniqueSources: definitionDetails.confluenceEntity ? [{
      id: (definitionReferenceDetails === null || definitionReferenceDetails === void 0 ? void 0 : definitionReferenceDetails.id) || '',
      title: (definitionReferenceDetails === null || definitionReferenceDetails === void 0 ? void 0 : definitionReferenceDetails.title) || '',
      url: definitionDetails.referenceUrl || '',
      type: (definitionReferenceDetails === null || definitionReferenceDetails === void 0 ? void 0 : definitionReferenceDetails.type) || '',
      lastModified: '',
      iconUrl: '',
      spaceName: (definitionReferenceDetails === null || definitionReferenceDetails === void 0 || (_definitionReferenceD = definitionReferenceDetails.space) === null || _definitionReferenceD === void 0 ? void 0 : _definitionReferenceD.name) || '',
      spaceUrl: null
    }] : [],
    nlpResultEditor: {
      name: ((_definitionDetails$ed = definitionDetails.editor) === null || _definitionDetails$ed === void 0 ? void 0 : _definitionDetails$ed.name) || '',
      id: ((_definitionDetails$ed2 = definitionDetails.editor) === null || _definitionDetails$ed2 === void 0 ? void 0 : _definitionDetails$ed2.accountId) || ''
    },
    disclaimer: null,
    errorState: null,
    format: NLPSearchResultFormat.MARKDOWN
  };
};

// Specifically checking for the \u200c character (ZERO WIDTH NON-JOINER) as the editor conditionally adds it.
// experienced an issue when adding multiple spaces without other characters, the \u200c character was added,
// throwing up the validation that an empty definition was valid CCSEARCH-4472
export var removeInvisibleCharacters = function removeInvisibleCharacters(str) {
  return str.replace(/[\u200c]/g, '');
};